import { classNames } from "../../../../../tool";
import styles from "../index.module.scss";
export default function ZONGX(props) {
  const { plays, selectPlays, onBet, playOddInfo, firstPlay, secondPlay } =
    props;
  return (
    <div className={styles.playContainer}>
      {plays.map((item, index) => {
        const active =
          selectPlays.findIndex((i) => i.code === item.code) !== -1;
        return (
          <div
            key={index}
            className={classNames(
              styles.ZONGX,
              styles.playItem,
              active ? styles.active : ""
            )}
            onClick={() => onBet(item)}
          >
            <div className={styles.name}>{item.name}</div>
            <div className={styles.odds}>
              {
                playOddInfo[
                  `LHC_${firstPlay.code}_${secondPlay.code || firstPlay.code}${
                    item.code
                  }`
                ]
              }
            </div>
          </div>
        );
      })}
    </div>
  );
}
